import { useStaticQuery, graphql } from "gatsby";

const UseColors = () => {
  const colorsData = useStaticQuery(graphql`
    {
      allContentfulColors {
        nodes {
          name
          url
        }
      }
    }
  `);
  return colorsData.allContentfulColors.nodes;
};

export default UseColors;
